import React from 'react';
import { OntarioRow, OntarioColumn } from '../../../theme';
import {
  StepIndicatorContainer,
  StepIndicatorBtnContainer,
  StepIndicatorSpan,
  HorizontalRule,
} from './styles';
import Button from './button';
import { FormSections, ProgramContainer } from '../../../entities/formTemplateDataType';
import { cleanup } from '../../../security/PublicSecure';
import { BackHome } from '../../../entities/Constants';
import { getRootComponent } from '../../../utilities/ElementUtils';

interface Props {
  withbackbtn: boolean;
  sectionSequence: number;
  totalSteps?: Set<number>;
  section?: FormSections;
  programContainer?: ProgramContainer;
  title: string;
  isEng: boolean;
  isTechicalErrorPage?:boolean;
  customOnclick?: () => void;
  callback?: (currentStep: number, totalSteps: Set<number>) => void;
}


export default class StepIndicator extends React.Component<Props> {
  
  constructor(props: Props) {
    super(props);

  }

  backToHome = (backButtonLabel: string) => {
    const lang = this.props.isEng ? "en" : "fr";
    const root = this.props.programContainer ? this.props.programContainer : getRootComponent(this.props.section);
    if (backButtonLabel === BackHome.Ontario[lang].label) {
      cleanup(root.CategoryId.toLowerCase(), root);
      window.location.replace(BackHome.Ontario[lang].url);
    } else if (backButtonLabel === BackHome.Home[lang].label) {
      cleanup(root.CategoryId.toLowerCase(), root);
      window.location.replace(BackHome.Home[lang].url);
    }
  }

   render() {
    let arr=[];
    let currentStep: number;
    let currentStepIndex: number;
    if (this.props.totalSteps) {
      arr = Array.from(this.props.totalSteps);
      currentStepIndex = arr.indexOf(this.props.sectionSequence);
    }

    let section: FormSections;
    let totalStepNumber: number;
    let profileInfo;
    let programContainer =this.props.programContainer;
    if (programContainer) {
      profileInfo = this.props.programContainer.Profile;
      section = this.props.programContainer.ListOfFormSections[currentStep];
      totalStepNumber = this.props.programContainer.ListOfFormSections.filter(p => p.Visible && !p.NotStep && !p.IsTechErrorPage && !p.IsInfoPage && !p.IsConfirmationPage).length;
    } else {
      profileInfo = this.props.section?.parent.Profile;
      section = this.props.section;
      programContainer = section?.parent as ProgramContainer
      const steps = programContainer?.ListOfFormSections?.filter(p => p.Visible && !p.NotStep && !p.IsTechErrorPage && !p.IsInfoPage && !p.IsConfirmationPage);
      totalStepNumber = steps?.length;
    }

    if (!this.props.withbackbtn) return false;

    // if (!this.props.section && !this.props.programContainer) {
    //   const confirmationPages = this.props.programContainer?.ListOfFormSections?.filter(p => p.IsConfirmationPage);
    //   if (confirmationPages && confirmationPages.length > 0) {
    //     section = confirmationPages[0];
    //   }
    // }

    let backButtonLabel, backUrl;
    const lang = this.props.isEng ? "en" : "fr";
    if (section && section?.BackButtonLabel) {
      backButtonLabel = this.props.isEng ? this.props.section.BackButtonLabel : this.props.section.BackButtonLabelFRA;
      if (backButtonLabel === BackHome.Home[lang].label) {
        backButtonLabel = profileInfo?.email ? BackHome.Home[lang].label : BackHome.Ontario[lang].label;
        backUrl = profileInfo?.email ? BackHome.Home[lang].url : BackHome.Ontario[lang].url;
      } else {
        backUrl = section.BackButtonURL;
      }
    } else {
      if (profileInfo && profileInfo.email) {
        // backButtonLabel = this.props.isEng ? (this.props.sectionSequence > 0 ? "Back" : "Back to home") : this.props.sectionSequence > 0 ? "Retour" : "Retour à l'accueil";
        backButtonLabel = this.props.sectionSequence > 0 ? BackHome.Back[lang].label : BackHome.Home[lang].label;
        if (backButtonLabel === BackHome.Home[lang].label) {
          backUrl = BackHome.Home[lang].url;
        } 
      } else {
        // backButtonLabel = this.props.isEng ? 
        //   (this.props.sectionSequence > 0 ? "Back" : this.props.programContainer?.Origin? this.props.programContainer?.Origin: "Back to Ontario.ca") : 
        //   this.props.sectionSequence > 0 ? "Retour" :this.props.programContainer?.OriginFRA?this.props.programContainer?.OriginFRA: "Revenir à Ontario.ca";
        backButtonLabel = this.props.sectionSequence > 0 ? BackHome.Back[lang].label : BackHome.Ontario[lang].label;
      }
    }
    
    return (
    
      <StepIndicatorContainer>
        <OntarioRow>
          {this.props.withbackbtn &&  (
            <StepIndicatorBtnContainer withbackbtn={this.props.withbackbtn}>
              <Button
                aria-label={this.props.title}
                appearance="stepIndicatorBtn"
                backIcon={this.props.withbackbtn}
                onClick={(e) => {
                  const target = e.target as HTMLButtonElement;
                  const label = target.innerText;
                  if (this.props.section && this.props.section?.BackButtonLabel) {
                    if(this.props.section.BackButtonURL){
                      if (this.props.section.BackButtonLabel === "Back to home" || this.props.section.BackButtonLabel === "Retour à l'accueil") {
                        cleanup(programContainer.CategoryId.toLowerCase(), programContainer);
                      }
                      window.location.replace(this.props.isEng? this.props.section.BackButtonURL: this.props.section.BackButtonURLFRA);
                    } else {
                      const url = process.env.PUBLIC_CXP_WEB_BASE_PATH + "/auth/signin?redirectUri=" + (this.props.isEng ? "" : "/fr") + "/dashboard"; 
                      console.log("back home: ", url);
                      cleanup(programContainer.CategoryId.toLowerCase(), programContainer);
                      window.location.replace(url);
                    }
                   
                  } else {
                    if (!section?.IsFrontPage && this.props.sectionSequence !== -1 && !this.props.isTechicalErrorPage && !this.props.section.IsConfirmationPage) {
                      this.backToHome(label);
                      currentStepIndex = arr.indexOf(this.props.sectionSequence);
                      const previousStepIndex = currentStepIndex - 1;
                      this.props.totalSteps?.delete(this.props.sectionSequence)
                      this.props.callback(arr[previousStepIndex], this.props.totalSteps);

                    } else if (this.props.sectionSequence == -1 || section?.IsFrontPage || this.props.isTechicalErrorPage || this.props.section.IsConfirmationPage) {
                      if (profileInfo && profileInfo.email) {
                        const path = this.props.isEng ? "/dashboard" : "/fr/dashboard";
                        const url = backUrl || process.env.PUBLIC_CXP_WEB_BASE_PATH + "/auth/signin?redirectUri=" + path;
                        cleanup(programContainer.CategoryId.toLowerCase(), programContainer);
                        window.location.replace(url);
                      } else {
                        window.location.replace(this.props.isEng ? this.props.programContainer.OriginURL? this.props.programContainer.OriginURL:"https://www.ontario.ca/page/serviceontario" : this.props.programContainer.OriginURLFRA? this.props.programContainer.OriginURLFRA:"https://www.ontario.ca/fr/page/serviceontario")
                      }
                    }
                  }

                }}>{backButtonLabel}
              </Button>

              {currentStepIndex>=0 && totalStepNumber>0 && (
                <div style={{ display: section?.NotStep || section?.NoStepIndicator ||this.props.sectionSequence==-1 || this.props.isTechicalErrorPage==true? "none" : "block" }}>
                  <div style={{ display: this.props.isEng ? "block" : "none" }}>
                    <StepIndicatorSpan>
                      {"Step " + (currentStepIndex + 1).toString() + (section?.NoTotalPages || section?.IsTechErrorPage  ? '' : " of " + totalStepNumber)}
                    </StepIndicatorSpan>
                  </div>

                  <div style={{ display: this.props.isEng ? "none" : "block" }}>
                    <StepIndicatorSpan>
                      {"Étape " + (currentStepIndex + 1).toString() + (section?.NoTotalPages || section?.IsTechErrorPage? '' : " de " + totalStepNumber)}
                    </StepIndicatorSpan>
                  </div>
                </div>
              )}
            </StepIndicatorBtnContainer>
          )}
          {!this.props.withbackbtn && (
            <StepIndicatorBtnContainer withbackbtn={this.props.withbackbtn}>
              <StepIndicatorSpan>

              </StepIndicatorSpan>
            </StepIndicatorBtnContainer>
          )}
          {section?.TitleInStepIndicator && <>
            <div style={{ display: section?.IsTerminationPage || section.CustomizedReviewPage ? "none" : "block" }} 
              className="ontario-h1 ontario-margin-bottom-0-!"
            >
              {this.props.isEng ? section?.ENUTitle : section?.FRATitle}
            </div>

            <div style={{ display: section?.IsTerminationPage || section.CustomizedReviewPage ? "none" : "block" }}
                className={!section?.IsTerminationPage && section?.ENUDescription ? "ontario-margin-top-24-! ontario-margin-bottom-40-!" : ""}>
                {this.props.isEng ? section?.ENUDescription : section?.FRADescription}
            </div>
          </>}
          <HorizontalRule />
        </OntarioRow>
      </StepIndicatorContainer>
    )
  }
}